/*** IMPORTS FROM imports-loader ***/
var define = false;

import Vue from 'vue'
import config from '../config';

const APIKEY = "m5**!Q)kk-x{jw.iGZ:O*S*mW)mdB3#:$i(c<}%f![~c<e$Uk9VGK,DcWyR0/hR";

export default {
	uploadImage (file, cb) {
		var formdata = new FormData();
        formdata.append('image', file);
        formdata.append('project', Vue.localStorage.get('project', config.default));

		Vue.http.post('https://admin.conflive.com/api/upload', formdata, {
   		headers: {
   			'Authorization': APIKEY,
       		'Content-Type': 'multipart/form-data'
   		}})
		.then(function (response) {
			console.log(response)
			cb(null, response.body)
		})
	}
}




// WEBPACK FOOTER //
// ./src/services/ConfliveHelperService.js